import { TableColumns } from "../../../../core/models/dashboard/tableColumns";

export const columns: TableColumns[] = [
  {
    header: "Client",
    field: "client",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: false,
  },
  {
    header: "Job Name",
    field: "jobName",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: false,
    isLongValueTrimmed: true,
  },
  {
    header: "Merch",
    field: "merch",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
  },
  {
    header: "Freight",
    field: "freight",
    link: true,
    linkField: "order",
    isDate: false,
    isNumber: true,
  },
  {
    header: "Tax",
    field: "tax",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
  },
  {
    header: "Inv Total",
    field: "invTotal",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
  },
  {
    header: "Order",
    field: "order",
    link: true,
    linkField: "order",
    isDate: false,
    isNumber: false,
  },
  {
    header: "Invoice",
    field: "invoice",
    link: true,
    linkField: "invoice",
    isDate: false,
    isNumber: false,
  },
  {
    header: "Invoice Date",
    field: "invoiceDate",
    link: false,
    linkField: "",
    isDate: true,
    isNumber: false,
  },
];
